var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14.501C10.866 14.501 14 11.367 14 7.50098C14 3.63499 10.866 0.500984 7 0.500984C3.13401 0.500984 0 3.63499 0 7.50098C0 11.367 3.13401 14.501 7 14.501Z",
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72517 9.52484L10.0352 7.50094H8.09403V6.18776C8.09403 5.63453 8.36474 5.0941 9.23494 5.0941H10.1179V3.37142C10.1179 3.37142 9.31664 3.23459 8.55079 3.23459C6.95214 3.23459 5.90672 4.20323 5.90672 5.9584V7.50094H4.12891V9.52484H5.90672V14.4163C6.26306 14.4724 6.62827 14.5009 7.00037 14.5009C7.37247 14.5009 7.73768 14.4714 8.09403 14.4163V9.52484H9.72517Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.41d092074a49e99db75e40a348c9b353.svg";
export { ForwardRef as ReactComponent };